import { Service } from '@angular/core';
import { LexplusDropdownMiniDto } from '@lexplus-user-api';

@Service()
export class UiHelperService {
  public createDropdownFromEnum(inputEnum: Record<string, number>): LexplusDropdownMiniDto[] {
    return Object.keys(inputEnum).map((key) => ({
      intId: inputEnum[key],
      stringId: '',
      label: key,
    }));
  }
}
